function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import _ from "lodash";
import { defineComponent, computed, ref } from "vue";
import { definePropType } from "@types-vue/props";
import { TranslationStatus } from "./index.type";
import { batchAiTranslate } from "@/api/ai";
export default defineComponent({
    props: {
        languageLists: {
            type: definePropType(Object),
            default: function() {}
        },
        source: {
            type: definePropType(String),
            default: "dm"
        },
        projectId: {
            type: Number,
            default: 0
        },
        sourceLanguage: String,
        targetLanguage: String,
        // 是否启动 AI 翻译，如果没有权限则传 false
        aiTranslatable: Boolean,
        aiTranslateDisabled: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var translateForm = ref(null);
        var translateLoading = ref(false);
        // 如果是同一个语种，代表是编辑模式，不允许翻译和编辑后立马生效
        var isSameSourceAndTarget = computed(function() {
            return props.sourceLanguage === props.targetLanguage;
        });
        var langLists = computed(function() {
            var tempList = [];
            if (!_.isEmpty(props.languageLists)) {
                _.each(props.languageLists, function(item) {
                    tempList = tempList.concat(item.children);
                });
            }
            return tempList;
        });
        var model = ref({});
        var selectLangLists = computed(function() {
            return langLists.value.filter(function(item) {
                return item.checked;
            });
        });
        var isIndeterminate = computed(function() {
            return langLists.value.some(function(item) {
                return item.checked;
            }) && !langLists.value.every(function(item) {
                return item.checked;
            });
        });
        var checkAll = computed({
            get: function get() {
                return langLists.value.every(function(item) {
                    return item.checked;
                });
            },
            set: function set(val) {
                langLists.value.forEach(function(item) {
                    item.checked = val;
                });
            }
        });
        var translateBtnProps = computed(function() {
            return {
                type: "primary",
                size: "mini",
                loading: translateLoading.value,
                disabled: props.aiTranslateDisabled || selectLangLists.value.length === 0 || props.targetLanguage === "" || isSameSourceAndTarget.value
            };
        });
        var getTranslateFailText = function(val) {
            if (val === TranslationStatus.fail) {
                return "translate-fail";
            }
            return "";
        };
        var translatePackageItemsToAiTranslateParams = function(items) {
            var params = items.map(function(item) {
                return {
                    source_language: props.sourceLanguage,
                    target_language: props.targetLanguage,
                    source_text: item.label
                };
            });
            return {
                batch: params,
                source: props.source,
                project_id: props.projectId
            };
        };
        var handleTranslate = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee1(items) {
                var setAllItemsToWaiting, setAllItemsToFail, itemProps, translateData, _translateData, translateResult;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            translateData = function _translateData1(data) {
                                return _translateData.apply(this, arguments);
                            };
                            _translateData = function __translateData() {
                                _translateData = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
                                    var batchSize, batches, translatedData, i, start, end, batchData, res, _translatedData;
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                batchSize = 200 // 批量翻译的数量
                                                ;
                                                batches = Math.ceil(data.length / batchSize) // 总共需要分多少批次翻译
                                                ;
                                                translatedData = [];
                                                i = 0;
                                            case 4:
                                                if (!(i < batches)) {
                                                    _ctx.next = 23;
                                                    break;
                                                }
                                                start = i * batchSize;
                                                end = start + batchSize > data.length ? data.length : start + batchSize;
                                                batchData = data.slice(start, end);
                                                _ctx.prev = 8;
                                                _ctx.next = 11;
                                                return batchAiTranslate(translatePackageItemsToAiTranslateParams(batchData));
                                            case 11:
                                                res = _ctx.sent;
                                                if (!res.data.code) {
                                                    ;
                                                    (_translatedData = translatedData).push.apply(_translatedData, _toConsumableArray(res.data.data.result));
                                                } else {
                                                    setAllItemsToFail();
                                                    console.error("\u7FFB\u8BD1\u7B2C ".concat(i + 1, " \u6279\u6570\u636E\u65F6\u51FA\u9519"));
                                                }
                                                _ctx.next = 20;
                                                break;
                                            case 15:
                                                _ctx.prev = 15;
                                                _ctx.t0 = _ctx["catch"](8);
                                                setAllItemsToFail();
                                                console.error("\u7FFB\u8BD1\u7B2C ".concat(i + 1, " \u6279\u6570\u636E\u65F6\u51FA\u9519"));
                                                throw new Error("\u7FFB\u8BD1\u7B2C ".concat(i + 1, " \u6279\u6570\u636E\u65F6\u51FA\u9519"));
                                            case 20:
                                                i++;
                                                _ctx.next = 4;
                                                break;
                                            case 23:
                                                return _ctx.abrupt("return", translatedData);
                                            case 24:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            8,
                                            15
                                        ]
                                    ]);
                                }));
                                return _translateData.apply(this, arguments);
                            };
                            setAllItemsToWaiting = function() {
                                items.forEach(function(item) {
                                    item.status = TranslationStatus.waiting;
                                });
                            };
                            setAllItemsToFail = function() {
                                items.forEach(function(item) {
                                    item.status = TranslationStatus.fail;
                                });
                            };
                            itemProps = [];
                            items.forEach(function(item) {
                                if (!_.isEmpty(props.languageLists)) {
                                    _.forEach(props.languageLists, function(value, key) {
                                        var itemIndex = value.children.indexOf(item);
                                        if (itemIndex !== -1) {
                                            itemProps.push("[".concat(key, "].children[").concat(itemIndex, "].value"));
                                        }
                                    });
                                }
                            });
                            translateLoading.value = true;
                            setAllItemsToWaiting();
                            ;
                            ;
                            _ctx1.prev = 10;
                            _ctx1.next = 13;
                            return translateData(items);
                        case 13:
                            translateResult = _ctx1.sent;
                            translateResult.forEach(function(item, index) {
                                var sourceItem = items[index];
                                if (item.success) {
                                    sourceItem.status = TranslationStatus.success;
                                    sourceItem.value = item.result_text;
                                } else {
                                    sourceItem.status = TranslationStatus.fail;
                                }
                            });
                            _ctx1.prev = 15;
                            _ctx1.next = 18;
                            return translateForm.value.validateField(itemProps);
                        case 18:
                            _ctx1.next = 23;
                            break;
                        case 20:
                            _ctx1.prev = 20;
                            _ctx1.t0 = _ctx1["catch"](15);
                            console.error(_ctx1.t0);
                        case 23:
                            _ctx1.next = 28;
                            break;
                        case 25:
                            _ctx1.prev = 25;
                            _ctx1.t1 = _ctx1["catch"](10);
                            setAllItemsToFail();
                        case 28:
                            _ctx1.prev = 28;
                            translateLoading.value = false;
                            return _ctx1.finish(28);
                        case 31:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1, null, [
                    [
                        10,
                        25,
                        28,
                        31
                    ],
                    [
                        15,
                        20
                    ]
                ]);
            }));
            return function handleTranslate(items) {
                return _ref.apply(this, arguments);
            };
        }();
        var validate = function(cb) {
            return translateForm.value.validate(cb);
        };
        var clearValidate = function() {
            translateForm.value.clearValidate();
        };
        var inputHandler = function(val, item) {
            if (isSameSourceAndTarget.value) {
                // 编辑模式下，编辑之后立马生效
                item.label = val;
                emit("inputChange", val, item);
                console.log(item);
            }
        };
        var getTranslatePackageData = function() {
            var data = [];
            if (!_.isEmpty(props.languageLists)) {
                _.forEach(props.languageLists, function(value, key) {
                    value.children.forEach(function(item) {
                        data.push({
                            key: item.key,
                            value: item.value
                        });
                    });
                });
            }
            return _defineProperty({}, props.targetLanguage, data);
        };
        return {
            isSameSourceAndTarget: isSameSourceAndTarget,
            translateForm: translateForm,
            model: model,
            langLists: langLists,
            isIndeterminate: isIndeterminate,
            checkAll: checkAll,
            selectLangLists: selectLangLists,
            handleTranslate: handleTranslate,
            getTranslateFailText: getTranslateFailText,
            translateBtnProps: translateBtnProps,
            validate: validate,
            inputHandler: inputHandler,
            getTranslatePackageData: getTranslatePackageData,
            clearValidate: clearValidate
        };
    }
});
